<div class="login-back-image-wrapper">
  <img class="login-back-image" src="assets/logo.png" alt="logo" />
</div>
<p [translate]="loadingText"></p>
<ion-button id="loading-alert-button" *ngIf="canCreateAlert" expand="block" [appAlert]="count">
  <span translate>Mobile.Alert</span>
  <app-alert-counter #count></app-alert-counter>
</ion-button>
<ng-container *ngFor="let button of unitCreationButtons">
  <ion-button class="ion-text-wrap" expand="block" (click)="button.handler()">
    <ion-label>
      {{ button.text }}
    </ion-label>
  </ion-button>
</ng-container>
